export default __webpack_public_path__ + "static/media/bruar_falls.560d8ece.jpg";